__turbopack_context__.v({
  "blockContainer": "ContentItemBlock-module-scss-module__o6QldG__blockContainer",
  "blocksBackgroundColor": "ContentItemBlock-module-scss-module__o6QldG__blocksBackgroundColor",
  "blocksFontColor": "ContentItemBlock-module-scss-module__o6QldG__blocksFontColor",
  "button": "ContentItemBlock-module-scss-module__o6QldG__button",
  "container": "ContentItemBlock-module-scss-module__o6QldG__container",
  "contentContainer": "ContentItemBlock-module-scss-module__o6QldG__contentContainer",
  "contentContainerBlurBottom": "ContentItemBlock-module-scss-module__o6QldG__contentContainerBlurBottom",
  "contentContainerHidden": "ContentItemBlock-module-scss-module__o6QldG__contentContainerHidden",
  "courseWorkImageContainer": "ContentItemBlock-module-scss-module__o6QldG__courseWorkImageContainer",
  "courseWorkImageContainerGreaterThanTwo": "ContentItemBlock-module-scss-module__o6QldG__courseWorkImageContainerGreaterThanTwo",
  "dateContainer": "ContentItemBlock-module-scss-module__o6QldG__dateContainer",
  "dateLocationContainer": "ContentItemBlock-module-scss-module__o6QldG__dateLocationContainer",
  "dateMedia": "ContentItemBlock-module-scss-module__o6QldG__dateMedia",
  "descriptionContainer": "ContentItemBlock-module-scss-module__o6QldG__descriptionContainer",
  "editButton": "ContentItemBlock-module-scss-module__o6QldG__editButton",
  "hiddenButton": "ContentItemBlock-module-scss-module__o6QldG__hiddenButton",
  "image": "ContentItemBlock-module-scss-module__o6QldG__image",
  "imageContainer": "ContentItemBlock-module-scss-module__o6QldG__imageContainer",
  "innerContentContainer": "ContentItemBlock-module-scss-module__o6QldG__innerContentContainer",
  "link": "ContentItemBlock-module-scss-module__o6QldG__link",
  "linkWithDate": "ContentItemBlock-module-scss-module__o6QldG__linkWithDate",
  "organizationTitle": "ContentItemBlock-module-scss-module__o6QldG__organizationTitle",
  "secondaryNavBackgroundColor": "ContentItemBlock-module-scss-module__o6QldG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ContentItemBlock-module-scss-module__o6QldG__themeBackgroundColor",
  "themeFontColor": "ContentItemBlock-module-scss-module__o6QldG__themeFontColor",
  "themeFontFamily": "ContentItemBlock-module-scss-module__o6QldG__themeFontFamily",
  "titleContainer": "ContentItemBlock-module-scss-module__o6QldG__titleContainer",
});
